<!--
  name : 김혜진
  desc : 비회원 로그인
  date : 2020-08-19
-->
<template>
 <v-dialog title="승인거부 사유" v-model="chainPassCheckDialog" persistent max-width="400px">
    <v-row no-gutters align="center" justify="center">
      <v-card id="popStyle02">
        <v-card-text>
          <v-text-field class="inputH48_01" v-model="passWord"
            type="password"
            label="블록체인 비밀번호"
            placeholder="블록체인 비밀번호를 입력해주세요."
            outlined
            rows="2"
            no-resize
            @keyup.enter="passCheck"
            ></v-text-field>
        </v-card-text>
        <span class="noti_chipV2">
          *비밀번호 찾기 문의는 고객센터(1588-8064)로 문의 부탁드립니다.
        </span>
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn text class="" v-on:click="passCheck">확인</v-btn>
          <v-btn text v-on:click="chainPassCheckDialog = false">취소</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-row>
  </v-dialog>
</template>
<script>

export default {
  name: 'chainPass',
  components: {
  },
  filters: {
  },
  props:{
    ctrNumber: String
  },
  data () {
    return {
      chainPassCheckDialog : false,
      passWord : ''
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    open () {
      this.passWord = ''
      this.chainPassCheckDialog = true
    },
    passCheck () {
      this.$emit('chainPassEvent', this.passWord)
      this.chainPassCheckDialog = false
    }
  }
}
</script>
<style scoped>
</style>
